import React, { Component } from 'react';
import { connect } from 'react-redux';
import { concat, filter, forEach, some, uniqBy, isNull } from 'lodash';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { scroller } from 'react-scroll';
import { asyncSimpleModal, checkIsNonSelectedList, getDifferenceList } from '../../lib/common';
import { pointActions } from '../../store/modules/point';
import PointGenerateWrap from '../../views/point/generate/PointGenerateWrap';
import { appActions } from '../../store/modules/app';
import {
  MAXIMUM_NUMBER_OF_POINT_GENERATE_USER,
  POINT_GENERATE_PAGE_SECTION_NAME,
} from '../../constants/service/app/pointConstants';
import {
  INVALID_REQUIRED_BULK_APPLY_POINT_DATA_MESSAGE,
  INVALID_REQUIRED_SELECT_USER_MESSAGE,
} from '../../constants/service/invalidMsg/pointInvalidMsg';
import { POINT_ISSUED_USER_MODEL } from '../../store/modules/point/models';

class PointGenerateContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { getPreparationGeneratePoint, setData } = this.props;

    /**
     *  pointCauseSelectList 받아오기
     */
    getPreparationGeneratePoint();

    /**
     *  페이지 초기화
     */
    setData({
      path: ['issuedUser'],
      value: POINT_ISSUED_USER_MODEL,
    });
  };

  getList = (data) => {
    const { getGeneratePointUserList, issuedUser } = this.props;
    const { userList } = issuedUser;
    const { searchOption, sortOption, pagination } = userList;

    getGeneratePointUserList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   * 발급 버튼 누르면 실행
   */
  onSubmit = () => {
    const { form, issuedUser, checkValidGeneratePoint } = this.props;
    const { selectedUserInfoList } = issuedUser;

    if (!selectedUserInfoList.length) {
      /**
       *  선택된 쿠폰이 있는지 체크
       */
      message.error('선택된 유저가 없습니다.');
      return;
    }

    /**
     *  form 유효성 체크
     */
    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, (err) => {
      if (err) {
        /**
         *  포인트 발급 페이지에서 form 유효성 체크하는 부분은
         *  포인트 발급할 유저를 선택하는 부분이므로
         *  유효하지 않은 form value 가 발생할 경우,
         *  해당 영역 섹션으로 이동을 하도록 함.
         */
        scroller.scrollTo(POINT_GENERATE_PAGE_SECTION_NAME.POINT_GENERATE_SELECTED_USER_LIST);
        return;
      }

      /**
       *  유효성 체크 하는 ctrl 로 보낸다.
       */
      checkValidGeneratePoint({
        selectedUserInfoList,
        targetAction: pointActions,
      });
    });
  };

  /**
   * 발급받을 유저 선택 callback
   */
  onCheckUser = async (list) => {
    const { setData, issuedUser } = this.props;
    const { userList, selectedUserInfoList } = issuedUser;

    let targetList = [];

    /**
     * 유저 발급 목록을 체크하는 경우
     */
    const addUserIdList = getDifferenceList(list, selectedUserInfoList, null, 'id');

    if (addUserIdList.length) {
      const addUserInfoList = filter(userList.list, (item) => some(addUserIdList, (id) => id === item.id));
      targetList = concat(selectedUserInfoList, addUserInfoList);
    }

    /**
     * 유저 발급 목록을 체크해제하는 경우
     */
    const subUserIdList = getDifferenceList(selectedUserInfoList, list, 'id', null);
    if (subUserIdList.length) {
      targetList = filter(selectedUserInfoList, (item) => !some(subUserIdList, (_item) => _item.id === item.id));
    }

    /**
     * 선택된 이벤트 아이템 리스트 중복 제거
     */
    targetList = uniqBy(targetList, 'id');

    /**
     *  유저 선택은 20 명이 최대
     *  그 이상은 엑셀 업로드를 이용하라고 안내한다.
     */
    if (targetList.length > MAXIMUM_NUMBER_OF_POINT_GENERATE_USER) {
      await asyncSimpleModal({
        type: 'error',
        title: '엑셀 일괄 발급 권장',
        message: `발급할 유저가 너무 많습니다.\n ${MAXIMUM_NUMBER_OF_POINT_GENERATE_USER}명 이상은 엑셀 일괄발급을 이용해 주세요.`,
      });
      return;
    }

    /**
     * 선택된 유저 정보 리스트 업데이트
     */
    setData({
      path: ['issuedUser', 'selectedUserInfoList'],
      value: targetList,
    });

    /**
     * 선택된 유저 id 리스트 업데이트
     */
    setData({
      path: ['issuedUser', 'selectedUserIdList'],
      value: list,
    });
  };

  /**
   *  type 을 바꿨을때 pointCauseId field 를 초기화 시켜주는 함수
   */
  initCause = (data) => {
    const { form } = this.props;

    form.setFields({ [`pointCauseId_${data.id}`]: null });
  };

  /**
   *  type, pointCauseId, amount 일괄 설정
   */
  applyBulkPointInfo = () => {
    const { form, issuedUser, setData } = this.props;
    const { pointBulkApply, selectedUserIdList } = issuedUser;
    const { type, pointCauseId, amount } = pointBulkApply;

    /**
     *  일괄 처리할 포인트 정보 체크
     */
    if (isNull(type) || isNull(pointCauseId) || isNull(amount)) {
      message.error(INVALID_REQUIRED_BULK_APPLY_POINT_DATA_MESSAGE);
      return;
    }

    /**
     *  선택된 유저가 있는지 체크
     */
    const isSelectedUserList = checkIsNonSelectedList(selectedUserIdList, INVALID_REQUIRED_SELECT_USER_MESSAGE);
    if (!isSelectedUserList) return;

    /**
     * 선택된 유저 모두 type, pointCauseId, amount 를 업데이트 한다.
     */
    forEach(selectedUserIdList, (item, index) => {
      /**
       *  실제 값 업데이트
       */
      setData({
        path: ['issuedUser', 'selectedUserInfoList', index, 'type'],
        value: type,
      });

      setData({
        path: ['issuedUser', 'selectedUserInfoList', index, 'pointCauseId'],
        value: pointCauseId,
      });

      setData({
        path: ['issuedUser', 'selectedUserInfoList', index, 'amount'],
        value: amount,
      });

      /**
       *  field 업데이트
       */
      form.setFieldsValue({ [`type_${item}`]: type });
      form.setFieldsValue({ [`pointCauseId_${item}`]: pointCauseId });
      form.setFieldsValue({ [`amount_${item}`]: amount });
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getGeneratePointUserListExcelDownload, issuedUser } = this.props;
    const { searchOption, sortOption } = issuedUser.userList;

    getGeneratePointUserListExcelDownload({
      searchOption,
      sortOption,
    });
  };

  render() {
    const { pointCauseSelectList, form, setData, issuedUser, toggleModal } = this.props;

    return (
      <PointGenerateWrap
        pointCauseSelectList={pointCauseSelectList}
        setData={setData}
        form={form}
        initCause={this.initCause}
        applyBulkPointInfo={this.applyBulkPointInfo}
        issuedUser={issuedUser}
        toggleModal={toggleModal}
        getList={this.getList}
        onCheckUser={this.onCheckUser}
        onSubmit={this.onSubmit}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    issuedUser: state.point.issuedUser,
    pointCauseSelectList: state.point.pointCauseSelectList,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPreparationGeneratePoint: pointActions.getPreparationGeneratePoint,
  getGeneratePointUserList: pointActions.getGeneratePointUserList,
  getGeneratePointUserListExcelDownload: pointActions.getGeneratePointUserListExcelDownload,
  toggleModal: pointActions.toggleModal,
  checkValidGeneratePoint: appActions.checkValidGeneratePoint,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(PointGenerateContainer));
